<template>
  <div class="bg-white border border-section_border border-b-0 rounded">
    <ul class="genre-place-list">
      <li v-for="place in places" v-bind:key="place.id" class="border-b">
        <genre-place @openPlace="$emit('openPlace', place)" :place="place" />
      </li>
    </ul>
  </div>
</template>

<script>
import GenrePlace from './GenrePlace'

export default {
  components: {
    GenrePlace
  },
  props: {
    genre: {
      type: Object,
      required: true
    }
  },
  computed: {
    places: function () {
      // 画像読み込みに時間がかかるため、最大のPOI数を20に制限
      return this.$store.getters['places/getPlacesByGenre'](this.genre).slice(0, 20)
    }
  }
}
</script>
